import '../stylesheets/pomodoro.css'
import '../javascripts/pomodoro/app.js'
import { createIcons, Bell, Users, GlassWater, SkipForward, Music } from 'lucide'

const MusicOff = [...Music, ['path', { d: 'm3 3 18 18' }]]

createIcons({
  icons: { Bell, Users, GlassWater, SkipForward, Music, MusicOff },
  attrs: { 'stroke-width': 1.75, 'aria-hidden': 'true', focusable: 'false' },
})
